<template>
  <div class="user-set main-panel large">
    <h1 class="panel-title">色卡库存结存表</h1>
    <div class="top">
      <div class="form">
        <div class="row">
          <div class="item col-1">
            <div class="label">店面/仓存</div>
            <el-select
              v-model="md"
              placeholder="请选择门店"
              style="width: 100%"
              clearable
              filterable
            >
              <el-option
                v-for="item in menlist"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="item col-1">
            <div class="label">品名</div>
            <el-select
              v-model="pmname"
              placeholder="请选择品名"
              style="width: 100%"
              clearable
              filterable
            >
              <el-option
                v-for="item in pmlist"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="item col-1">
            <div class="form-options">
              <el-button size="small" class="custom-btn" @click="search"
                >查询</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-table :data="list" border style="width: 100%" class="custom-table">
      <el-table-column type="index" align="center" width="50" label="序号" />
      <el-table-column align="center" prop="storeName" label="店面/仓存" />
      <el-table-column
        align="center"
        prop="productName"
        label="品名"
        show-overflow-tooltip
      />
      <el-table-column align="center" prop="number" label="数量" />
      <!-- 加载更多插槽，和前面页面完全统一 -->
      <template #append>
        <div
          class="load-more"
          :class="{ 'no-more': noMore }"
          v-if="list.length"
          @click="loadMore"
        >
          {{ noMore ? "没有数据了~" : "点击加载下一页" }}
        </div>
      </template>
    </el-table>
  </div>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance, watch } from "vue";
const { proxy } = getCurrentInstance();

const list = ref([]); //表格数据列表
const pmname = ref(""); // 产品编号
const pmlist = ref([]);
const md = ref(""); //门店名称
const menlist = ref([]); //门店列表

// 分页变量（统一配置）
const pages = ref({ page: 1, size: 50 });
const noMore = ref(false);
const loading = ref(false);

// 缓存值
const STORAGE_KEY = "/publish-clothes/colorcard/colorcardStock";

// 监听查询条件
watch([md, pmname], () => {
  const searchParams = {
    pmname: pmname.value,
    md: md.value,
  };
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(searchParams));
});

// 读取缓存回填表单
const loadSearchCache = () => {
  const cacheStr = sessionStorage.getItem(STORAGE_KEY);
  if (cacheStr) {
    try {
      const cache = JSON.parse(cacheStr);
      md.value = cache.md ?? "";
      pmname.value = cache.pmname ?? "";
    } catch (e) {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  }
};

const mdList = async () => {
  try {
    const res = await proxy.$api.Colorcard.get({});
    if (res.data.code == "200") {
      menlist.value = res.data.data.list.filter(
        (item) => item.name !== "" && item.name !== null
      );
    } else {
      proxy.$message.error("获取门店列表失败");
      menlist.value = [];
    }
  } catch (error) {
    console.error("获取门店列表异常：", error);
    proxy.$message.error("网络错误，获取门店列表失败");
    menlist.value = [];
  }
};

const pmList = async () => {
  try {
    const res = await proxy.$api.Colorcard.gets({});
    if (res.data.code == "200") {
      pmlist.value = res.data.data.list;
    } else {
      proxy.$message.error("获取产品列表失败");
      pmlist.value = [];
    }
  } catch (error) {
    console.error("获取产品列表异常：", error);
    proxy.$message.error("网络错误，获取产品列表失败");
    pmlist.value = [];
  }
};

// 查询：重置页码清空列表
const search = () => {
  pages.value.page = 1;
  noMore.value = false;
  list.value = [];
  getList();
};
// 加载下一页
const loadMore = async () => {
  await getList(true);
};

// 改造getList，支持追加
const getList = async (isLoadMore = false) => {
  if (noMore.value || loading.value) return;
  const sendata = {
    currentPage: pages.value.page,
    pageSize: pages.value.size,
    storeId: md.value,
    productId: pmname.value,
  };
  try {
    loading.value = true;
    const res = await proxy.$api.Colorcard.getStock(sendata);
    if (res.data.code == 200) {
      const currentData = Array.isArray(res.data.data.list)
        ? res.data.data.list
        : [];
      if (pages.value.page === 1) {
        list.value = currentData;
      } else {
        list.value = [...list.value, ...currentData];
      }
      const total = res.data.data.total;
      noMore.value =
        total != null
          ? list.value.length >= total
          : currentData.length < pages.value.size;
      pages.value.page += 1;
    } else if (!isLoadMore) {
      list.value = [];
      proxy.$message.error("获取列表失败：" + (res.data.msg || "未知错误"));
    }
  } catch (error) {
    console.error("获取列表异常：", error);
    if (!isLoadMore) list.value = [];
  } finally {
    loading.value = false;
  }
};

onMounted(() => {
  mdList();
  pmList();
  loadSearchCache();
  getList();
});
</script>

<style lang="scss" scoped>
@import "./colorcardStock.scss";
:deep(.custom-btn) {
  background-color: #ffae00 !important;
  border-color: #ffae00 !important;
  color: #333;
}
.main-panel.large {
  background-color: #fff;
}
:deep(.el-dialog) {
  margin-top: 15vh !important;
}
:deep(.el-dialog--center .el-dialog__body) {
  height: 180px;
}
.panel-title {
  color: #666;
}
:deep(.el-select .el-input__inner) {
  background-color: #fff;
}
:deep(.el-select .el-input__inner:focus) {
  background-color: #fff;
}
:deep(.custom-table) {
  background-color: #fff !important;
  .el-table__header-wrapper {
    background-color: #fff !important;
    .el-table__header {
      background-color: #fff !important;
      th {
        background-color: #fff !important;
      }
    }
  }
  .el-table__body-wrapper {
    background-color: #fff !important;
    .el-table__body {
      background-color: #fff !important;
      td {
        background-color: #fff !important;
      }
    }
  }
}
:deep(.el-dialog--center) {
  background-color: #fff !important;
}
/* 和其他页面统一的加载更多样式 */
.load-more {
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: #666;
  cursor: pointer;
  &:hover {
    background: #e9ecef;
  }
  &.no-more {
    color: #999;
    cursor: default;
  }
}
</style>
